import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

const SortIcon = ({ field, sortBy, sortOrder }) => {
  if (sortBy !== field) return null;
  return sortOrder === 'ASC' ? (
    <ChevronUpIcon className="size-4 inline ml-1" />
  ) : (
    <ChevronDownIcon className="size-4 inline ml-1" />
  );
};

// Click-to-sort table header. `field` is the sort key handed back to onSort;
// `align="right"` for numeric columns. Padding comes from className (default px-4).
const SortableTh = ({ field, label, sortBy, sortOrder, onSort, align = 'left', className = 'px-4' }) => (
  <th
    scope="col"
    aria-sort={sortBy === field ? (sortOrder === 'ASC' ? 'ascending' : 'descending') : 'none'}
    className={clsx(
      'py-3 text-xs font-medium text-gray-500 uppercase tracking-wider',
      align === 'right' ? 'text-right' : 'text-left',
      className
    )}
  >
    <button
      type="button"
      onClick={() => onSort(field)}
      className={clsx(
        'flex w-full items-center rounded transition-colors hover:text-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wrg-blue-500',
        align === 'right' ? 'justify-end text-right' : 'text-left'
      )}
    >
      {label}
      <SortIcon field={field} sortBy={sortBy} sortOrder={sortOrder} />
    </button>
  </th>
);

export default SortableTh;
